function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function getRequirement(requirementId, reqObj) {
  return reqObj && reqObj[requirementId];
}
export function externalLinkSelector(requirementId) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function (state) {
    var _state$api;
    // if the redux store is not set up
    if (!(state !== null && state !== void 0 && (_state$api = state.api) !== null && _state$api !== void 0 && _state$api.entities && (state.api.entities.application_document_requirements || state.api.entities.application_questions_requirements || state.api.entities.application_receipt_requirements || state.api.entities.application_disclaimer_requirements || state.api.entities.application_payment_requirements) && state.api.entities.application_external_links)) {
      return [];
    }
    var _state$api$entities = state.api.entities,
      documentRequirements = _state$api$entities.application_document_requirements,
      questionRequirements = _state$api$entities.application_questions_requirements,
      receiptRequirements = _state$api$entities.application_receipt_requirements,
      disclaimerRequirements = _state$api$entities.application_disclaimer_requirements,
      paymentRequirements = _state$api$entities.application_payment_requirements;
    var requirement = getRequirement(requirementId, documentRequirements) || getRequirement(requirementId, questionRequirements) || getRequirement(requirementId, receiptRequirements) || getRequirement(requirementId, paymentRequirements) || getRequirement(requirementId, disclaimerRequirements);
    if (!requirement || !requirement.relationships || !requirement.relationships.application_external_links || !requirement.relationships.application_external_links.data) {
      return [];
    }
    return requirement.relationships.application_external_links.data.map(function (item) {
      return item.id;
    }).map(function (id) {
      return state.api.entities.application_external_links[id];
    });
  };
}
export function additionalAttachmentSelector(requirementId) {
  return function (state) {
    var _state$api2;
    // if the redux store is not set up
    if (!(state !== null && state !== void 0 && (_state$api2 = state.api) !== null && _state$api2 !== void 0 && _state$api2.entities && (state.api.entities.application_document_requirements || state.api.entities.application_questions_requirements || state.api.entities.application_receipt_requirements || state.api.entities.application_disclaimer_requirements) && state.api.entities.application_additional_attachments)) {
      return [];
    }
    var _state$api$entities2 = state.api.entities,
      documentRequirements = _state$api$entities2.application_document_requirements,
      questionRequirements = _state$api$entities2.application_questions_requirements,
      receiptRequirements = _state$api$entities2.application_receipt_requirements,
      paymentRequirements = _state$api$entities2.application_payment_requirements,
      disclaimerRequirements = _state$api$entities2.application_disclaimer_requirements;
    var requirement = getRequirement(requirementId, documentRequirements) || getRequirement(requirementId, questionRequirements) || getRequirement(requirementId, receiptRequirements) || getRequirement(requirementId, paymentRequirements) || getRequirement(requirementId, disclaimerRequirements);
    if (!requirement || !requirement.relationships || !requirement.relationships.application_additional_attachments || !requirement.relationships.application_additional_attachments.data) {
      return [];
    }
    return requirement.relationships.application_additional_attachments.data.map(function (item) {
      return item.id;
    }).map(function (id) {
      return state.api.entities.application_additional_attachments[id];
    });
  };
}
export function attachmentSelector(requirementId) {
  return function (state) {
    var _state$api3;
    // if the redux store is not set up
    if (!(state !== null && state !== void 0 && (_state$api3 = state.api) !== null && _state$api3 !== void 0 && _state$api3.entities && (state.api.entities.application_document_requirements || state.api.entities.application_receipt_requirements) && state.api.entities.attachments)) {
      return [];
    }
    var _state$api$entities3 = state.api.entities,
      documentRequirements = _state$api$entities3.application_document_requirements,
      receiptRequirements = _state$api$entities3.application_receipt_requirements;
    var requirement = getRequirement(requirementId, documentRequirements) || getRequirement(requirementId, receiptRequirements);
    if (!requirement || !requirement.relationships || !requirement.relationships.attachments || !requirement.relationships.attachments.data) {
      return [];
    }
    return requirement.relationships.attachments.data.map(function (item) {
      return item.id;
    }).map(function (id) {
      return state.api.entities.attachments[id];
    });
  };
}
export function questionSelector(requirementId) {
  return function (state) {
    var _state$api4, _state$api4$entities;
    // if the redux store is not set up
    if (!(state !== null && state !== void 0 && (_state$api4 = state.api) !== null && _state$api4 !== void 0 && (_state$api4$entities = _state$api4.entities) !== null && _state$api4$entities !== void 0 && _state$api4$entities.application_questions)) {
      return [];
    }
    var questionRequirements = state.api.entities.application_questions_requirements;
    var requirement = getRequirement(requirementId, questionRequirements);
    if (!requirement || !requirement.relationships || !requirement.relationships.application_questions || !requirement.relationships.application_questions.data) {
      return [];
    }
    return requirement.relationships.application_questions.data.map(function (item) {
      return item.id;
    }).map(function (id) {
      return state.api.entities.application_questions[id];
    });
  };
}
function filterRequirements(requirements) {
  if (!requirements) return null;
  var items = Object.values(requirements);
  return items.map(function (requirement) {
    return _objectSpread(_objectSpread({}, requirement.attributes), {}, {
      id: requirement.id
    });
  }).filter(function (requirement) {
    if (requirement.applyproof_compatible) {
      return requirement.status === 'status_completed' && requirement.verification_status === 'status_success';
    }
    if (requirement.official) {
      return requirement.status === 'status_completed';
    }
    return false;
  });
}
export function documentRequirementSelector(state) {
  var _state$api5, _state$api5$entities;
  return filterRequirements(state === null || state === void 0 ? void 0 : (_state$api5 = state.api) === null || _state$api5 === void 0 ? void 0 : (_state$api5$entities = _state$api5.entities) === null || _state$api5$entities === void 0 ? void 0 : _state$api5$entities.application_document_requirements);
}
export function receiptRequirementSelector(state) {
  var _state$api6, _state$api6$entities;
  return filterRequirements(state === null || state === void 0 ? void 0 : (_state$api6 = state.api) === null || _state$api6 === void 0 ? void 0 : (_state$api6$entities = _state$api6.entities) === null || _state$api6$entities === void 0 ? void 0 : _state$api6$entities.application_receipt_requirements);
}
export function questionRequirementSelector(state) {
  var _state$api7, _state$api7$entities;
  return filterRequirements(state === null || state === void 0 ? void 0 : (_state$api7 = state.api) === null || _state$api7 === void 0 ? void 0 : (_state$api7$entities = _state$api7.entities) === null || _state$api7$entities === void 0 ? void 0 : _state$api7$entities.application_questions_requirements);
}
export function disclaimerRequirementSelector(state) {
  var _state$api8, _state$api8$entities;
  return filterRequirements(state === null || state === void 0 ? void 0 : (_state$api8 = state.api) === null || _state$api8 === void 0 ? void 0 : (_state$api8$entities = _state$api8.entities) === null || _state$api8$entities === void 0 ? void 0 : _state$api8$entities.application_disclaimer_requirements);
}
export function paymentRequirementSelector(state) {
  var _state$api9, _state$api9$entities;
  return filterRequirements(state === null || state === void 0 ? void 0 : (_state$api9 = state.api) === null || _state$api9 === void 0 ? void 0 : (_state$api9$entities = _state$api9.entities) === null || _state$api9$entities === void 0 ? void 0 : _state$api9$entities.application_payment_requirements);
}